import { type SVGProps } from 'react';

export const PadlockIcon = (props: SVGProps<SVGSVGElement>): React.ReactElement => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 11.79C16 7.5139 19.7238 4.04004 23.9999 4.04004C28.2761 4.04004 32 7.5139 32 11.79V21H41V44H7V21H16V11.79ZM17 21H31V11.79C31 8.06618 27.7238 5.04004 23.9999 5.04004C20.2761 5.04004 17 8.06618 17 11.79V21ZM8 22V43H40V22H8ZM19.4199 31.7C19.4199 29.1739 21.4738 27.12 23.9999 27.12C26.5261 27.12 28.5799 29.1739 28.5799 31.7C28.5799 33.4879 27.5552 35.0389 26.0599 35.7909V41H21.9399V35.7856C20.4445 35.033 19.4199 33.4846 19.4199 31.7ZM23.9999 28.12C22.0261 28.12 20.4199 29.7262 20.4199 31.7C20.4199 33.1289 21.2611 34.3663 22.4817 34.9371L22.4936 34.9427C22.5142 34.953 22.5336 34.962 22.5618 34.9749L22.5641 34.9759C22.5906 34.9879 22.6252 35.0037 22.6635 35.0228L22.9399 35.161V40H25.0599V35.1353L25.3694 35.0078C26.6679 34.4726 27.5799 33.1913 27.5799 31.7C27.5799 29.7262 25.9738 28.12 23.9999 28.12Z"
        fill="#404040"
      />
    </svg>
  );
};
